// tslint:disable-next-line:no-any
export default (val: any, message = 'assertion failed') => {
  if (!val) {
    throw new Error(message);
  }
};



// WEBPACK FOOTER //
// ./app/gamma/src/util/assert.ts